import { useState } from 'react';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  TypeGetShippingLabelsShippingLabelIdParams,
  TypeGetShippingLabelsShippingLabelIdResponse,
} from '~/types/delivery-agency.types';

const useGetShippingLabelsShippingLabelId = () => {
  const { runAsync } = useAsyncHandler();

  const [responseData, setResponseData] = useState<TypeGetShippingLabelsShippingLabelIdResponse['data'] | null>(null);

  const getShippingLabelDetail = useAPI<
    TypeGetShippingLabelsShippingLabelIdParams,
    TypeGetShippingLabelsShippingLabelIdResponse
  >({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPING_LABEL_DETAIL,
    method: 'get',
  });

  const requestShippingLabelDetail = async (
    params: TypeGetShippingLabelsShippingLabelIdParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetShippingLabelsShippingLabelIdResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getShippingLabelDetail({ pathParams: `/${params.shippingLabelId}` }), {
      onSuccess: ({ data }) => {
        setResponseData(data);
        onSuccess?.(data);
      },
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestShippingLabelDetail, responseData };
};

export default useGetShippingLabelsShippingLabelId;
